<template>
  <div id="pageTable" class="mainView">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar dark color="primary" flat dense cad>
              <v-btn icon @click="$router.go(-1)">
                <v-icon>keyboard_arrow_left</v-icon>
              </v-btn>
              <v-toolbar-title class="subheading">운행 정보</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.passengerUsageHeader1"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{props.item.id}}</td>
                  <td class="text-sm-center">{{props.item.callOption}}</td>
                  <td class="text-sm-center">{{props.item.startLocationName}}</td>
                  <td class="text-sm-center">{{props.item.endLocationName}}</td>
                  <td class="text-sm-center">{{props.item.startTimestamp}}</td>
                  <td class="text-sm-center">{{props.item.endTimestamp}}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-divider></v-divider>

            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.passengerUsageHeader2"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">{{props.item.driverName}}</td>
                  <td class="text-sm-center">{{props.item.carModelName}}</td>
                  <td class="text-sm-center">{{props.item.carNum}}</td>
                  <td class="text-sm-center">{{props.item.driverScore ? props.item.driverScore : ''}}</td>
                </template>
              </v-data-table>
            </v-list>

            <v-divider></v-divider>

            <v-list three-line subheader>
              <v-data-table
                      :headers="complex.passengerUsageHeader3"
                      :items="complex.items"
                      hide-actions
                      class="elevation-1"
              >
                <template slot="items" slot-scope="props">
                  <td class="text-sm-center">
                    <template v-if="props.item.matchingHistory">
                      {{ props.item.matchingHistory.pickupUserId1 == props.item.passengerId ? props.item.matchingHistory.callHistory1.soloPredictTotalFee : props.item.matchingHistory.callHistory2.soloPredictTotalFee }} 원
                    </template>
                    <template v-if="props.item.callHistory">
                      {{ props.item.callHistory.soloPredictTotalFee }} 원
                    </template>
                  </td>
                  <td class="text-sm-center">
                    <template v-if="props.item.matchingHistory">
                      {{ props.item.matchingHistory.pickupUserId1 == props.item.passengerId ? props.item.matchingHistory.predictTaxiFee1 : props.item.matchingHistory.predictTaxiFee2 }} 원
                    </template>
                  </td>
                  <td class="text-sm-center">{{props.item.totalTaxiFee}} 원</td>
                  <td class="text-sm-center">{{props.item.extraFee}} 원</td>
                  <td class="text-sm-center">{{props.item.serviceFee}} 원</td>
                  <td class="text-sm-center">{{props.item.shareDiscount}} 원</td>
                  <td class="text-sm-center">{{props.item.couponDiscount}} 원</td>
                  <td class="text-sm-center">{{props.item.pointUsed}} 원</td>
                  <td class="text-sm-center">{{(props.item.totalTaxiFee + props.item.extraFee + props.item.serviceFee) - props.item.shareDiscount - props.item.couponDiscount - props.item.pointUsed}} 원</td>
                  <td class="text-sm-center">{{props.item.payMethod}}</td>
                </template>
              </v-data-table>
            </v-list>

            <template v-if="passengerUsage.matchingHistory">
              <v-list three-line subheader>
                <v-data-table
                        :headers="complex.banbanHeader1"
                        :items="complex.items"
                        hide-actions
                        class="elevation-1"
                >
                  <template slot="items" slot-scope="props">
                    <td class="text-sm-center">{{props.item.matchingHistory.frontUserId == props.item.passengerId ? '앞 좌석' : '뒷 좌석' }}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.pickupUserId1 == props.item.passengerId ? '먼저' : '나중에' }}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.dropOffUserId1 == props.item.passengerId ? '먼저' : '나중에' }}</td>
                    <td class="text-sm-center">{{props.item.mateId}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.callHistory1 == props.item.mateId ? props.item.matchingHistory.callHistory1.startLocationName : props.item.matchingHistory.callHistory2.startLocationName}}</td>
                    <td class="text-sm-center">{{props.item.matchingHistory.callHistory1 == props.item.mateId ? props.item.matchingHistory.callHistory1.endLocationName : props.item.matchingHistory.callHistory2.endLocationName}}</td>
                  </template>
                </v-data-table>
              </v-list>
            </template>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import VWidget from '@/components/VWidget';

export default {
  components: {
    VWidget
  },
  data () {
    return {
      passengerUsage: {},
      complex: {
        passengerUsageHeader1: [
          {
            text: '이용이력 고유번호',
            align: 'center',
            sortable: false
          },
          {
            text: '콜 종류',
            align: 'center',
            sortable: false
          },
          {
            text: '출발지',
            align: 'center',
            sortable: false
          },
          {
            text: '도착지',
            align: 'center',
            sortable: false
          },
          {
            text: '승차시간',
            align: 'center',
            sortable: false
          },
          {
            text: '하차시간',
            align: 'center',
            sortable: false
          },
        ],
        passengerUsageHeader2: [
          {
            text: '기사 이름',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 차량',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 차량번호',
            align: 'center',
            sortable: false
          },
          {
            text: '기사 평가점수',
            align: 'center',
            sortable: false
          },
        ],
        passengerUsageHeader3: [
          {
            text: '혼자 탔을 때 예상요금',
            align: 'center',
            sortable: false
          },
          {
            text: '같이 탔을 때 예상요금',
            align: 'center',
            sortable: false
          },
          {
            text: '운행요금',
            align: 'center',
            sortable: false
          },
          {
            text: '추가요금(통행료)',
            align: 'center',
            sortable: false
          },
          {
            text: '서비스이용요금',
            align: 'center',
            sortable: false
          },
          {
            text: '동승할인',
            align: 'center',
            sortable: false
          },
          {
            text: '쿠폰할인',
            align: 'center',
            sortable: false
          },
          {
            text: '포인트할인',
            align: 'center',
            sortable: false
          },
          {
            text: '최종 결제요금',
            align: 'center',
            sortable: false
          },
          {
            text: '결제수단',
            align: 'center',
            sortable: false
          }
        ],
        banbanHeader1: [
          {
            text: '좌석',
            align: 'center',
            sortable: false
          },
          {
            text: '승차',
            align: 'center',
            sortable: false
          },
          {
            text: '하차',
            align: 'center',
            sortable: false
          },
          {
            text: '동승객 고유번호',
            align: 'center',
            sortable: false
          },
          {
            text: '동승객 출발지',
            align: 'center',
            sortable: false
          },
          {
            text: '동승객 도착지',
            align: 'center',
            sortable: false
          },
        ],
        items: []
      }
    };
  },
  watch: {
    '$route.params' () {
      this.banbanCreated();
    }
  },
  mounted () {
    for (let i = 0; i < this.$parent.$children.length; i++) {
      if (this.$parent.$children[i].chkAutoReload != null) {
        this.$parent.$children[i].chkAutoReload();
      }
    }

    this.banbanCreated();
  },
  methods: {
    banbanCreated () {
      const parameters = {
        method: 'passengerUsageRecordDetail',
        'id': this.$route.params.id
      };

      this.$store.dispatch('banbanAPI', parameters)
              .then(({ data }) => {
                console.log(data);

                this.passengerUsage = data;
                this.complex.items = [data];

                top.getApp.progress.dialog = false;
              })
              .catch((error) => {
                if (top.getApp.commonError == null) {
                  alert('알 수 없는 오류가 발생했습니다. 관리자에게 문의하세요.');
                }
                top.getApp.commonError = null;
                top.getApp.progress.dialog = false;
              });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/usage/PassengerUsageHistoryDetail.vue